import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: reports.RubricColumn.
export default class RubricColumn extends Fragment {
  declare [Type]: 'reports/rubric-column';

  @attr('number', { defaultValue: 0 })
  declare column: number;

  @attr('string', { defaultValue: '' })
  declare label: string;
}
